import React from 'react';
import './burger.scss';
import burger from 'assets/icons/burger.svg';

const Burger = ({onClick}) =>
    <button className = "burger_btn" onClick = { onClick }>
        <img src = { burger } alt="תפריט" />
    </button>
export default Burger;